export const LOGOUT = 'LOGOUT'
export const SET_ERROR = 'SET_ERROR'

export const O365_REGISTER_REQUEST = 'O365_REGISTER_REQUEST'
export const O365_REGISTER_SUCCESS = 'O365_REGISTER_SUCCESS'
export const O365_REGISTER_FAILURE = 'O365_REGISTER_FAILURE'

export const O365_LOAD_EVENTS_REQUEST = 'O365_LOAD_EVENTS_REQUEST'
export const O365_LOAD_EVENTS_SUCCESS = 'O365_LOAD_EVENTS_SUCCESS'
export const O365_LOAD_EVENTS_FAILURE = 'O365_LOAD_EVENTS_FAILURE'

export const O365_LOAD_EVENT_REQUEST = 'O365_LOAD_EVENT_REQUEST'
export const O365_LOAD_EVENT_SUCCESS = 'O365_LOAD_EVENT_SUCCESS'
export const O365_LOAD_EVENT_FAILURE = 'O365_LOAD_EVENT_FAILURE'

export const O365_LOAD_EDIT_EVENT_REQUEST = 'O365_LOAD_EDIT_EVENT_REQUEST'
export const O365_LOAD_EDIT_EVENT_SUCCESS = 'O365_LOAD_EDIT_EVENT_SUCCESS'
export const O365_LOAD_EDIT_EVENT_FAILURE = 'O365_LOAD_EDIT_EVENT_FAILURE'

export const O365_LOAD_USER_INFO_REQUEST = 'O365_LOAD_USER_INFO_REQUEST'
export const O365_LOAD_USER_INFO_SUCCESS = 'O365_LOAD_USER_INFO_SUCCESS'
export const O365_LOAD_USER_INFO_FAILURE = 'O365_LOAD_USER_INFO_FAILURE'

export const O365_CREATE_EVENT_REQUEST = 'O365_CREATE_EVENT_REQUEST'
export const O365_CREATE_EVENT_SUCCESS = 'O365_CREATE_EVENT_SUCCESS'
export const O365_CREATE_EVENT_FAILURE = 'O365_CREATE_EVENT_FAILURE'

export const O365_UPDATE_EVENT_REQUEST = 'O365_UPDATE_EVENT_REQUEST'
export const O365_UPDATE_EVENT_SUCCESS = 'O365_UPDATE_EVENT_SUCCESS'
export const O365_UPDATE_EVENT_FAILURE = 'O365_UPDATE_EVENT_FAILURE'

export const O365_DELETE_EVENT_REQUEST = 'O365_DELETE_EVENT_REQUEST'
export const O365_DELETE_EVENT_SUCCESS = 'O365_DELETE_EVENT_SUCCESS'
export const O365_DELETE_EVENT_FAILURE = 'O365_DELETE_EVENT_FAILURE'

export const BSRS_LOGIN_REQUEST = 'BSRS_LOGIN_REQUEST'
export const BSRS_LOGIN_SUCCESS = 'BSRS_LOGIN_SUCCESS'
export const BSRS_LOGIN_FAILURE = 'BSRS_LOGIN_FAILURE'

export const PROFILE_LOGIN_REQUEST = 'PROFILE_LOGIN_REQUEST'
export const PROFILE_LOGIN_SUCCESS = 'PROFILE_LOGIN_SUCCESS'
export const PROFILE_LOGIN_FAILURE = 'PROFILE_LOGIN_FAILURE'

export const O365_ACCEPT_EVENT_REQUEST = 'O365_ACCEPT_EVENT_REQUEST'
export const O365_ACCEPT_EVENT_SUCCESS = 'O365_ACCEPT_EVENT_SUCCESS'
export const O365_ACCEPT_EVENT_FAILURE = 'O365_ACCEPT_EVENT_FAILURE'

export const O365_TENTATIVE_EVENT_REQUEST = 'O365_TENTATIVE_EVENT_REQUEST'
export const O365_TENTATIVE_EVENT_SUCCESS = 'O365_TENTATIVE_EVENT_SUCCESS'
export const O365_TENTATIVE_EVENT_FAILURE = 'O365_TENTATIVE_EVENT_FAILURE'

export const O365_DECLINE_EVENT_REQUEST = 'O365_DECLINE_EVENT_REQUEST'
export const O365_DECLINE_EVENT_SUCCESS = 'O365_DECLINE_EVENT_SUCCESS'
export const O365_DECLINE_EVENT_FAILURE = 'O365_DECLINE_EVENT_FAILURE'

export const CORE_LOAD_ORDERS_REQUEST = 'CORE_LOAD_ORDERS_REQUEST'
export const CORE_LOAD_ORDERS_SUCCESS = 'CORE_LOAD_ORDERS_SUCCESS'
export const CORE_LOAD_ORDERS_FAILURE = 'CORE_LOAD_ORDERS_FAILURE'

export const CORE_LOAD_ORDER_DETAIL_REQUEST = 'CORE_LOAD_ORDER_DETAIL_REQUEST'
export const CORE_LOAD_ORDER_DETAIL_SUCCESS = 'CORE_LOAD_ORDER_DETAIL_SUCCESS'
export const CORE_LOAD_ORDER_DETAIL_FAILURE = 'CORE_LOAD_ORDER_DETAIL_FAILURE'

export const CORE_CHANGE_ORDER_AMOUNT = 'CORE_CHANGE_ORDER_AMOUNT'

export const CORE_UPSERT_ORDERS_REQUEST = 'CORE_UPSERT_ORDERS_REQUEST'
export const CORE_UPSERT_ORDERS_SUCCESS = 'CORE_UPSERT_ORDERS_SUCCESS'
export const CORE_UPSERT_ORDERS_FAILURE = 'CORE_UPSERT_ORDERS_FAILURE'

export const CORE_LOAD_CHEKIN_REQUEST = 'CORE_LOAD_CHEKIN_REQUEST'
export const CORE_LOAD_CHEKIN_SUCCESS = 'CORE_LOAD_CHEKIN_SUCCESS'
export const CORE_LOAD_CHEKIN_FAILURE = 'CORE_LOAD_CHEKIN_FAILURE'

export const CORE_CREATE_CHECKIN_REQUEST = 'CORE_CREATE_CHECKIN_REQUEST'
export const CORE_CREATE_CHECKIN_SUCCESS = 'CORE_CREATE_CHECKIN_SUCCESS'
export const CORE_CREATE_CHECKIN_FAILURE = 'CORE_CREATE_CHECKIN_FAILURE'

export const O365_CHECKOUT_EVENT_REQUEST = 'O365_CHECKOUT_EVENT_REQUEST'
export const O365_CHECKOUT_EVENT_SUCCESS = 'O365_CHECKOUT_EVENT_SUCCESS'
export const O365_CHECKOUT_EVENT_FAILURE = 'O365_CHECKOUT_EVENT_FAILURE'

export const O365_LOAD_PEOPLE_REQUEST = 'O365_LOAD_PEOPLE_REQUEST'
export const O365_LOAD_PEOPLE_SUCCESS = 'O365_LOAD_PEOPLE_SUCCESS'
export const O365_LOAD_PEOPLE_FAILURE = 'O365_LOAD_PEOPLE_FAILURE'

export const O365_LOAD_LOCATION_REQUEST = 'O365_LOAD_LOCATION_REQUEST'
export const O365_LOAD_LOCATION_SUCCESS = 'O365_LOAD_LOCATION_SUCCESS'
export const O365_LOAD_LOCATION_FAILURE = 'O365_LOAD_LOCATION_FAILURE'

export const CORE_LOAD_LOCATIONS_REQUEST = 'CORE_LOAD_LOCATIONS_REQUEST'
export const CORE_LOAD_LOCATIONS_SUCCESS = 'CORE_LOAD_LOCATIONS_SUCCESS'
export const CORE_LOAD_LOCATIONS_FAILURE = 'CORE_LOAD_LOCATIONS_FAILURE'

export const O365_SEARCH_SLOT_REQUEST = 'O365_SEARCH_SLOT_REQUEST'
export const O365_SEARCH_SLOT_SUCCESS = 'O365_SEARCH_SLOT_SUCCESS'
export const O365_SEARCH_SLOT_FAILURE = 'O365_SEARCH_SLOT_FAILURE'

export const CORE_INTEGRATION_O365_GO_ADD_CLIENT_ID = 'CORE_INTEGRATION_O365_GO_ADD_CLIENT_ID'
export const CORE_INTEGRATION_O365_GO_ADMIN_CONSENT = 'CORE_INTEGRATION_O365_GO_ADMIN_CONSENT'
export const CORE_INTEGRATION_O365_GO_SAVE_DATA = 'CORE_INTEGRATION_O365_GO_SAVE_DATA'

export const CORE_INTEGRATION_O365_ADD_CLIENT_ID = 'CORE_INTEGRATION_O365_ADD_CLIENT_ID'
export const CORE_INTEGRATION_O365_ADMIN_CONSENT = 'CORE_INTEGRATION_O365_ADMIN_CONSENT'
export const CORE_INTEGRATION_O365_REQUEST = 'CORE_INTEGRATION_O365_REQUEST'
export const CORE_INTEGRATION_O365_SUCCESS = 'CORE_INTEGRATION_O365_SUCCESS'
export const CORE_INTEGRATION_O365_FAILURE = 'CORE_INTEGRATION_O365_FAILURE'

export const CORE_CREATE_ROOM_REQUEST = 'CORE_CREATE_ROOM_REQUEST'
export const CORE_CREATE_ROOM_SUCCESS = 'CORE_CREATE_ROOM_SUCCESS'
export const CORE_CREATE_ROOM_FAILURE = 'CORE_CREATE_ROOM_FAILURE'

export const CORE_LOAD_ROOM_REQUEST = 'CORE_LOAD_ROOM_REQUEST'
export const CORE_LOAD_ROOM_SUCCESS = 'CORE_LOAD_ROOM_SUCCESS'
export const CORE_LOAD_ROOM_FAILURE = 'CORE_LOAD_ROOM_FAILURE'

export const CORE_FIND_ROOM_REQUEST = 'CORE_FIND_ROOM_REQUEST'
export const CORE_FIND_ROOM_SUCCESS = 'CORE_FIND_ROOM_SUCCESS'
export const CORE_FIND_ROOM_FAILURE = 'CORE_FIND_ROOM_FAILURE'

export const CORE_UPDATE_ROOM_REQUEST = 'CORE_UPDATE_ROOM_REQUEST'
export const CORE_UPDATE_ROOM_SUCCESS = 'CORE_UPDATE_ROOM_SUCCESS'
export const CORE_UPDATE_ROOM_FAILURE = 'CORE_UPDATE_ROOM_FAILURE'

export const CORE_DELETE_ROOM_REQUEST = 'CORE_DELETE_ROOM_REQUEST'
export const CORE_DELETE_ROOM_SUCCESS = 'CORE_DELETE_ROOM_SUCCESS'
export const CORE_DELETE_ROOM_FAILURE = 'CORE_DELETE_ROOM_FAILURE'

export const O365_DELETE_ROOM_SUBSCRIBE_REQUEST = 'O365_DELETE_ROOM_SUBSCRIBE_REQUEST'
export const O365_DELETE_ROOM_SUBSCRIBE_SUCCESS = 'O365_DELETE_ROOM_SUBSCRIBE_SUCCESS'
export const O365_DELETE_ROOM_SUBSCRIBE_FAILURE = 'O365_DELETE_ROOM_SUBSCRIBE_FAILURE'

export const O365_CREATE_ROOM_SUBSCRIBE_REQUEST = 'O365_CREATE_ROOM_SUBSCRIBE_REQUEST'
export const O365_CREATE_ROOM_SUBSCRIBE_SUCCESS = 'O365_CREATE_ROOM_SUBSCRIBE_SUCCESS'
export const O365_CREATE_ROOM_SUBSCRIBE_FAILURE = 'O365_CREATE_ROOM_SUBSCRIBE_FAILURE'

export const O365_LOAD_ROOMS_REQUEST = 'O365_LOAD_ROOMS_REQUEST'
export const O365_LOAD_ROOMS_SUCCESS = 'O365_LOAD_ROOMS_SUCCESS'
export const O365_LOAD_ROOMS_FAILURE = 'O365_LOAD_ROOMS_FAILURE'

export const O365_LOAD_ROOMS_INFO_REQUEST = 'O365_LOAD_ROOMS_INFO_REQUEST'
export const O365_LOAD_ROOMS_INFO_SUCCESS = 'O365_LOAD_ROOMS_INFO_SUCCESS'
export const O365_LOAD_ROOMS_INFO_FAILURE = 'O365_LOAD_ROOMS_INFO_FAILURE'

export const O365_LOAD_USERS_REQUEST = 'O365_LOAD_USERS_REQUEST'
export const O365_LOAD_USERS_SUCCESS = 'O365_LOAD_USERS_SUCCESS'
export const O365_LOAD_USERS_FAILURE = 'O365_LOAD_USERS_FAILURE'

export const BSRS_SERVICE_TOKEN_REQUEST = 'BSRS_SERVICE_TOKEN_REQUEST'
export const BSRS_SERVICE_TOKEN_SUCCESS = 'BSRS_SERVICE_TOKEN_SUCCESS'
export const BSRS_SERVICE_TOKEN_FAILURE = 'BSRS_SERVICE_TOKEN_FAILURE'

export const CORE_LOAD_ROOMS_REQUEST = 'CORE_LOAD_ROOMS_REQUEST'
export const CORE_LOAD_ROOMS_SUCCESS = 'CORE_LOAD_ROOMS_SUCCESS'
export const CORE_LOAD_ROOMS_FAILURE = 'CORE_LOAD_ROOMS_FAILURE'

export const CORE_LOAD_ROOMS_SUBSCRIBE_REQUEST = 'CORE_LOAD_ROOMS_SUBSCRIBE_REQUEST'
export const CORE_LOAD_ROOMS_SUBSCRIBE_SUCCESS = 'CORE_LOAD_ROOMS_SUBSCRIBE_SUCCESS'
export const CORE_LOAD_ROOMS_SUBSCRIBE_FAILURE = 'CORE_LOAD_ROOMS_SUBSCRIBE_FAILURE'

export const CORE_LOAD_REPORT_REQUEST = 'CORE_LOAD_REPORT_REQUEST'
export const CORE_LOAD_REPORT_SUCCESS = 'CORE_LOAD_REPORT_SUCCESS'
export const CORE_LOAD_REPORT_FAILURE = 'CORE_LOAD_REPORT_FAILURE'

export const CORE_LOAD_LOCATIONS_REPORT_REQUEST = 'CORE_LOAD_LOCATIONS_REPORT_REQUEST'
export const CORE_LOAD_LOCATIONS_REPORT_SUCCESS = 'CORE_LOAD_LOCATIONS_REPORT_SUCCESS'
export const CORE_LOAD_LOCATIONS_REPORT_FAILURE = 'CORE_LOAD_LOCATIONS_REPORT_FAILURE'

export const CORE_CREATE_USER_REQUEST = 'CORE_CREATE_USER_REQUEST'
export const CORE_CREATE_USER_SUCCESS = 'CORE_CREATE_USER_SUCCESS'
export const CORE_CREATE_USER_FAILURE = 'CORE_CREATE_USER_FAILURE'

export const CORE_LOAD_USERS_REQUEST = 'CORE_LOAD_USERS_REQUEST'
export const CORE_LOAD_USERS_SUCCESS = 'CORE_LOAD_USERS_SUCCESS'
export const CORE_LOAD_USERS_FAILURE = 'CORE_LOAD_USERS_FAILURE'

export const CORE_LOAD_USER_REQUEST = 'CORE_LOAD_USER_REQUEST'
export const CORE_LOAD_USER_SUCCESS = 'CORE_LOAD_USER_SUCCESS'
export const CORE_LOAD_USER_FAILURE = 'CORE_LOAD_USER_FAILURE'

export const CORE_UPDATE_USER_REQUEST = 'CORE_UPDATE_USER_REQUEST'
export const CORE_UPDATE_USER_SUCCESS = 'CORE_UPDATE_USER_SUCCESS'
export const CORE_UPDATE_USER_FAILURE = 'CORE_UPDATE_USER_FAILURE'

export const CORE_DELETE_USER_REQUEST = 'CORE_DELETE_USER_REQUEST'
export const CORE_DELETE_USER_SUCCESS = 'CORE_DELETE_USER_SUCCESS'
export const CORE_DELETE_USER_FAILURE = 'CORE_DELETE_USER_FAILURE'

export const CORE_USER_CHANGEPASS_REQUEST = 'CORE_USER_CHANGEPASS_REQUEST'
export const CORE_USER_CHANGEPASS_SUCCESS = 'CORE_USER_CHANGEPASS_SUCCESS'
export const CORE_USER_CHANGEPASS_FAILURE = 'CORE_USER_CHANGEPASS_FAILURE'

export const CORE_EDIT_USER_REQUEST = 'CORE_EDIT_USER_REQUEST'
export const CORE_EDIT_USER_SUCCESS = 'CORE_EDIT_USER_SUCCESS'
export const CORE_EDIT_USER_FAILURE = 'CORE_EDIT_USER_FAILURE'

export const CORE_LOAD_USER_INFO_REQUEST = 'CORE_LOAD_USER_INFO_REQUEST'
export const CORE_LOAD_USER_INFO_SUCCESS = 'CORE_LOAD_USER_INFO_SUCCESS'
export const CORE_LOAD_USER_INFO_FAILURE = 'CORE_LOAD_USER_INFO_FAILURE'

export const CORE_CHANGE_PASSWORD_REQUEST = 'CORE_CHANGE_PASSWORD_REQUEST'
export const CORE_CHANGE_PASSWORD_SUCCESS = 'CORE_CHANGE_PASSWORD_SUCCESS'
export const CORE_CHANGE_PASSWORD_FAILURE = 'CORE_CHANGE_PASSWORD_FAILURE'

export const CORE_GET_INTEGRATION_REQUEST = 'CORE_GET_INTEGRATION_REQUEST'
export const CORE_GET_INTEGRATION_SUCCESS = 'CORE_GET_INTEGRATION_SUCCESS'
export const CORE_GET_INTEGRATION_FAILURE = 'CORE_GET_INTEGRATION_FAILURE'

export const CORE_LOAD_SETTING_INFO_REQUEST = 'CORE_LOAD_SETTING_INFO_REQUEST'
export const CORE_LOAD_SETTING_INFO_SUCCESS = 'CORE_LOAD_SETTING_INFO_SUCCESS'
export const CORE_LOAD_SETTING_INFO_FAILURE = 'CORE_LOAD_SETTING_INFO_FAILURE'

export const CORE_CHANGE_SETTING_REQUEST = 'CORE_CHANGE_SETTING_REQUEST'
export const CORE_CHANGE_SETTING_SUCCESS = 'CORE_CHANGE_SETTING_SUCCESS'
export const CORE_CHANGE_SETTING_FAILURE = 'CORE_CHANGE_SETTING_FAILURE'

export const CORE_LOAD_USERREPORT_REQUEST = 'CORE_LOAD_USERREPORT_REQUEST'
export const CORE_LOAD_USERREPORT_SUCCESS = 'CORE_LOAD_USERREPORT_SUCCESS'
export const CORE_LOAD_USERREPORT_FAILURE = 'CORE_LOAD_USERREPORT_FAILURE'

export const CORE_LOAD_ROOMREPORT_REQUEST = 'CORE_LOAD_ROOMREPORT_REQUEST'
export const CORE_LOAD_ROOMREPORT_SUCCESS = 'CORE_LOAD_ROOMREPORT_SUCCESS'
export const CORE_LOAD_ROOMREPORT_FAILURE = 'CORE_LOAD_ROOMREPORT_FAILURE'

export const CORE_LOAD_USERSUMMARY_REQUEST = 'CORE_LOAD_USERSUMMARY_REQUEST'
export const CORE_LOAD_USERSUMMARY_SUCCESS = 'CORE_LOAD_USERSUMMARY_SUCCESS'
export const CORE_LOAD_USERSUMMARY_FAILURE = 'CORE_LOAD_USERSUMMARY_FAILURE'

export const CORE_LOAD_ROOMSUMMARY_REQUEST = 'CORE_LOAD_ROOMSUMMARY_REQUEST'
export const CORE_LOAD_ROOMSUMMARY_SUCCESS = 'CORE_LOAD_ROOMSUMMARY_SUCCESS'
export const CORE_LOAD_ROOMSUMMARY_FAILURE = 'CORE_LOAD_ROOMSUMMARY_FAILURE'

export const CORE_LOAD_REPORTSUMMARY_REQUEST = 'CORE_LOAD_REPORTSUMMARY_REQUEST'
export const CORE_LOAD_REPORTSUMMARY_SUCCESS = 'CORE_LOAD_REPORTSUMMARY_SUCCESS'
export const CORE_LOAD_REPORTSUMMARY_FAILURE = 'CORE_LOAD_REPORTSUMMARY_FAILURE'

export const CORE_LOAD_ALLAMENITY_REQUEST = 'CORE_LOAD_ALLAMENITY_REQUEST'
export const CORE_LOAD_ALLAMENITY_SUCCESS = 'CORE_LOAD_ALLAMENITY_SUCCESS'
export const CORE_LOAD_ALLAMENITY_FAILURE = 'CORE_LOAD_ALLAMENITY_FAILURE'

export const CORE_DELETE_AMENITY_REQUEST = 'CORE_DELETE_AMENITY_REQUEST'
export const CORE_DELETE_AMENITY_SUCCESS = 'CORE_DELETE_AMENITY_SUCCESS'
export const CORE_DELETE_AMENITY_FAILURE = 'CORE_DELETE_AMENITY_FAILURE'

export const CORE_LOAD_AMENITYINFO_REQUEST = 'CORE_LOAD_AMENITYINFO_REQUEST'
export const CORE_LOAD_AMENITYINFO_SUCCESS = 'CORE_LOAD_AMENITYINFO_SUCCESS'
export const CORE_LOAD_AMENITYINFO_FAILURE = 'CORE_LOAD_AMENITYINFO_FAILURE'

export const CORE_CREATE_AMENITY_REQUEST = 'CORE_CREATE_AMENITY_REQUEST'
export const CORE_CREATE_AMENITY_SUCCESS = 'CORE_CREATE_AMENITY_SUCCESS'
export const CORE_CREATE_AMENITY_FAILURE = 'CORE_CREATE_AMENITY_FAILURE'

export const CORE_UPDATE_AMENITYINFO_REQUEST = 'CORE_UPDATE_AMENITYINFO_REQUEST'
export const CORE_UPDATE_AMENITYINFO_SUCCESS = 'CORE_UPDATE_AMENITYINFO_SUCCESS'
export const CORE_UPDATE_AMENITYINFO_FAILURE = 'CORE_UPDATE_AMENITYINFO_FAILURE'

export const CORE_LOAD_ALL_PROFILE_REQUEST = 'CORE_LOAD_ALL_PROFILE_REQUEST'
export const CORE_LOAD_ALL_PROFILE_SUCCESS = 'CORE_LOAD_ALL_PROFILE_SUCCESS'
export const CORE_LOAD_ALL_PROFILE_FAILURE = 'CORE_LOAD_ALL_PROFILE_FAILURE'

export const CORE_LOAD_PROFILE_INFO_REQUEST = 'CORE_LOAD_PROFILE_INFO_REQUEST'
export const CORE_LOAD_PROFILE_INFO_SUCCESS = 'CORE_LOAD_PROFILE_INFO_SUCCESS'
export const CORE_LOAD_PROFILE_INFO_FAILURE = 'CORE_LOAD_PROFILE_INFO_FAILURE'

export const CORE_CREATE_PROFILE_REQUEST = 'CORE_CREATE_PROFILE_REQUEST'
export const CORE_CREATE_PROFILE_SUCCESS = 'CORE_CREATE_PROFILE_SUCCESS'
export const CORE_CREATE_PROFILE_FAILURE = 'CORE_CREATE_PROFILE_FAILURE'

export const CORE_UPDATE_PROFILE_REQUEST = 'CORE_UPDATE_PROFILE_REQUEST'
export const CORE_UPDATE_PROFILE_SUCCESS = 'CORE_UPDATE_PROFILE_SUCCESS'
export const CORE_UPDATE_PROFILE_FAILURE = 'CORE_UPDATE_PROFILE_FAILURE'

export const CORE_DELETE_PROFILE_REQUEST = 'CORE_DELETE_PROFILE_REQUEST'
export const CORE_DELETE_PROFILE_SUCCESS = 'CORE_DELETE_PROFILE_SUCCESS'
export const CORE_DELETE_PROFILE_FAILURE = 'CORE_DELETE_PROFILE_FAILURE'

export const CORE_LOAD_USERGROUPS_REQUEST = 'CORE_LOAD_USERGROUPS_REQUEST'
export const CORE_LOAD_USERGROUPS_SUCCESS = 'CORE_LOAD_USERGROUPS_SUCCESS'
export const CORE_LOAD_USERGROUPS_FAILURE = 'CORE_LOAD_USERGROUPS_FAILURE'

export const CORE_LOAD_LIST_USERGROUPS_REQUEST = 'CORE_LOAD_LIST_USERGROUPS_REQUEST'
export const CORE_LOAD_LIST_USERGROUPS_SUCCESS = 'CORE_LOAD_LIST_USERGROUPS_SUCCESS'
export const CORE_LOAD_LIST_USERGROUPS_FAILURE = 'CORE_LOAD_LIST_USERGROUPS_FAILURE'

export const CORE_LOAD_USERGROUP_REQUEST = 'CORE_LOAD_USERGROUP_REQUEST'
export const CORE_LOAD_USERGROUP_SUCCESS = 'CORE_LOAD_USERGROUP_SUCCESS'
export const CORE_LOAD_USERGROUP_FAILURE = 'CORE_LOAD_USERGROUP_FAILURE'

export const CORE_CREATE_USERGROUP_REQUEST = 'CORE_CREATE_USERGROUP_REQUEST'
export const CORE_CREATE_USERGROUP_SUCCESS = 'CORE_CREATE_USERGROUP_SUCCESS'
export const CORE_CREATE_USERGROUP_FAILURE = 'CORE_CREATE_USERGROUP_FAILURE'

export const CORE_UPDATE_USERGROUP_REQUEST = 'CORE_UPDATE_USERGROUP_REQUEST'
export const CORE_UPDATE_USERGROUP_SUCCESS = 'CORE_UPDATE_USERGROUP_SUCCESS'
export const CORE_UPDATE_USERGROUP_FAILURE = 'CORE_UPDATE_USERGROUP_FAILURE'

export const CORE_DELETE_USERGROUP_REQUEST = 'CORE_DELETE_USERGROUP_REQUEST'
export const CORE_DELETE_USERGROUP_SUCCESS = 'CORE_DELETE_USERGROUP_SUCCESS'
export const CORE_DELETE_USERGROUP_FAILURE = 'CORE_DELETE_USERGROUP_FAILURE'

export const CORE_LOAD_ACTIONS_REQUEST = 'CORE_LOAD_ACTIONS_REQUEST'
export const CORE_LOAD_ACTIONS_SUCCESS = 'CORE_LOAD_ACTIONS_SUCCESS'
export const CORE_LOAD_ACTIONS_FAILURE = 'CORE_LOAD_ACTIONS_FAILURE'

export const CORE_LOAD_ALLFBS_REQUEST = 'CORE_LOAD_ALLFBS_REQUEST'
export const CORE_LOAD_ALLFBS_SUCCESS = 'CORE_LOAD_ALLFBS_SUCCESS'
export const CORE_LOAD_ALLFBS_FAILURE = 'CORE_LOAD_ALLFBS_FAILURE'

export const CORE_DELETE_FBS_REQUEST = 'CORE_DELETE_FBS_REQUEST'
export const CORE_DELETE_FBS_SUCCESS = 'CORE_DELETE_FBS_SUCCESS'
export const CORE_DELETE_FBS_FAILURE = 'CORE_DELETE_FBS_FAILURE'

export const CORE_LOAD_FBSINFO_REQUEST = 'CORE_LOAD_FBSINFO_REQUEST'
export const CORE_LOAD_FBSINFO_SUCCESS = 'CORE_LOAD_FBSINFO_SUCCESS'
export const CORE_LOAD_FBSINFO_FAILURE = 'CORE_LOAD_FBSINFO_FAILURE'

export const CORE_CREATE_FBS_REQUEST = 'CORE_CREATE_FBS_REQUEST'
export const CORE_CREATE_FBS_SUCCESS = 'CORE_CREATE_FBS_SUCCESS'
export const CORE_CREATE_FBS_FAILURE = 'CORE_CREATE_FBS_FAILURE'

export const CORE_UPDATE_FBSINFO_REQUEST = 'CORE_UPDATE_FBSINFO_REQUEST'
export const CORE_UPDATE_FBSINFO_SUCCESS = 'CORE_UPDATE_FBSINFO_SUCCESS'
export const CORE_UPDATE_FBSINFO_FAILURE = 'CORE_UPDATE_FBSINFO_FAILURE'

export const CORE_GET_INTEGRATION_INFO_REQUEST = 'CORE_GET_INTEGRATION_INFO_REQUEST'
export const CORE_GET_INTEGRATION_INFO_SUCCESS = 'CORE_GET_INTEGRATION_INFO_SUCCESS'
export const CORE_GET_INTEGRATION_INFO_FAILURE = 'CORE_GET_INTEGRATION_INFO_FAILURE'

export const CORE_LOAD_STATUSUSER_REQUEST = 'CORE_LOAD_STATUSUSER_REQUEST'
export const CORE_LOAD_STATUSUSER_SUCCESS = 'CORE_LOAD_STATUSUSER_SUCCESS'
export const CORE_LOAD_STATUSUSER_FAILURE = 'CORE_LOAD_STATUSUSER_FAILURE'

export const CORE_LOAD_USERSUM_REQUEST = 'CORE_LOAD_USERSUM_REQUEST'
export const CORE_LOAD_USERSUM_SUCCESS = 'CORE_LOAD_USERSUM_SUCCESS'
export const CORE_LOAD_USERSUM_FAILURE = 'CORE_LOAD_USERSUM_FAILURE'

export const CORE_LOAD_ROOMSUM_REQUEST = 'CORE_LOAD_ROOMSUM_REQUEST'
export const CORE_LOAD_ROOMSUM_SUCCESS = 'CORE_LOAD_ROOMSUM_SUCCESS'
export const CORE_LOAD_ROOMSUM_FAILURE = 'CORE_LOAD_ROOMSUM_FAILURE'

export const CORE_LOAD_ROOMTEMP_REQUEST = 'CORE_LOAD_ROOMTEMP_REQUEST'
export const CORE_LOAD_ROOMTEMP_SUCCESS = 'CORE_LOAD_ROOMTEMP_SUCCESS'
export const CORE_LOAD_ROOMTEMP_FAILURE = 'CORE_LOAD_ROOMTEMP_FAILURE'

export const CORE_LOAD_TOPROOMRESERVE_REQUEST = 'CORE_LOAD_TOPROOMRESERVE_REQUEST'
export const CORE_LOAD_TOPROOMRESERVE_SUCCESS = 'CORE_LOAD_TOPROOMRESERVE_SUCCESS'
export const CORE_LOAD_TOPROOMRESERVE_FAILURE = 'CORE_LOAD_TOPROOMRESERVE_FAILURE'

export const CORE_LOAD_TOPUSERRESERVE_REQUEST = 'CORE_LOAD_TOPUSERRESERVE_REQUEST'
export const CORE_LOAD_TOPUSERRESERVE_SUCCESS = 'CORE_LOAD_TOPUSERRESERVE_SUCCESS'
export const CORE_LOAD_TOPUSERRESERVE_FAILURE = 'CORE_LOAD_TOPUSERRESERVE_FAILURE'

export const CORE_LOAD_ROOMDETAIL_REQUEST = 'CORE_LOAD_ROOMDETAIL_REQUEST'
export const CORE_LOAD_ROOMDETAIL_SUCCESS = 'CORE_LOAD_ROOMDETAIL_SUCCESS'
export const CORE_LOAD_ROOMDETAIL_FAILURE = 'CORE_LOAD_ROOMDETAIL_FAILURE'

export const CORE_LOAD_TERM_REQUEST = 'CORE_LOAD_TERM_REQUEST'
export const CORE_LOAD_TERM_SUCCESS = 'CORE_LOAD_TERM_SUCCESS'
export const CORE_LOAD_TERM_FAILURE = 'CORE_LOAD_TERM_FAILURE'

export const CORE_UPDATE_TERM_REQUEST = 'CORE_UPDATE_TERM_REQUEST'
export const CORE_UPDATE_TERM_SUCCESS = 'CORE_UPDATE_TERM_SUCCESS'
export const CORE_UPDATE_TERM_FAILURE = 'CORE_UPDATE_TERM_FAILURE'

export const CORE_LOAD_FAQ_REQUEST = 'CORE_LOAD_FAQ_REQUEST'
export const CORE_LOAD_FAQ_SUCCESS = 'CORE_LOAD_FAQ_SUCCESS'
export const CORE_LOAD_FAQ_FAILURE = 'CORE_LOAD_FAQ_FAILURE'

export const CORE_UPDATE_FAQ_REQUEST = 'CORE_UPDATE_FAQ_REQUEST'
export const CORE_UPDATE_FAQ_SUCCESS = 'CORE_UPDATE_FAQ_SUCCESS'
export const CORE_UPDATE_FAQ_FAILURE = 'CORE_UPDATE_FAQ_FAILURE'

export const CORE_LOAD_CONTACT_US_REQUEST = 'CORE_LOAD_CONTACT_US_REQUEST'
export const CORE_LOAD_CONTACT_US_SUCCESS = 'CORE_LOAD_CONTACT_US_SUCCESS'
export const CORE_LOAD_CONTACT_US_FAILURE = 'CORE_LOAD_CONTACT_US_FAILURE'

export const CORE_UPDATE_CONTACT_US_REQUEST = 'CORE_UPDATE_CONTACT_US_REQUEST'
export const CORE_UPDATE_CONTACT_US_SUCCESS = 'CORE_UPDATE_CONTACT_US_SUCCESS'
export const CORE_UPDATE_CONTACT_US_FAILURE = 'CORE_UPDATE_CONTACT_US_FAILURE'

export const CORE_LOAD_REPORTROOMSTATUS_REQUEST = 'CORE_LOAD_REPORTROOMSTATUS_REQUEST'
export const CORE_LOAD_REPORTROOMSTATUS_SUCCESS = 'CORE_LOAD_REPORTROOMSTATUS_SUCCESS'
export const CORE_LOAD_REPORTROOMSTATUS_FAILURE = 'CORE_LOAD_REPORTROOMSTATUS_FAILURE'

export const CORE_LOAD_ALL_CATEGORY_REQUEST = 'CORE_LOAD_ALL_CATEGORY_REQUEST'
export const CORE_LOAD_ALL_CATEGORY_SUCCESS = 'CORE_LOAD_ALL_CATEGORY_SUCCESS'
export const CORE_LOAD_ALL_CATEGORY_FAILURE = 'CORE_LOAD_ALL_CATEGORY_FAILURE'

export const CORE_LOAD_ALLBUILDING_REQUEST = 'CORE_LOAD_ALLBUILDING_REQUEST'
export const CORE_LOAD_ALLBUILDING_SUCCESS = 'CORE_LOAD_ALLBUILDING_SUCCESS'
export const CORE_LOAD_ALLBUILDING_FAILURE = 'CORE_LOAD_ALLBUILDING_FAILURE'

export const CORE_DELETE_BUILDING_REQUEST = 'CORE_DELETE_BUILDING_REQUEST'
export const CORE_DELETE_BUILDING_SUCCESS = 'CORE_DELETE_BUILDING_SUCCESS'
export const CORE_DELETE_BUILDING_FAILURE = 'CORE_DELETE_BUILDING_FAILURE'

export const CORE_LOAD_BUILDINGINFO_REQUEST = 'CORE_LOAD_BUILDINGINFO_REQUEST'
export const CORE_LOAD_BUILDINGINFO_SUCCESS = 'CORE_LOAD_BUILDINGINFO_SUCCESS'
export const CORE_LOAD_BUILDINGINFO_FAILURE = 'CORE_LOAD_BUILDINGINFO_FAILURE'

export const CORE_UPDATE_BUILDINGINFO_REQUEST = 'CORE_UPDATE_BUILDINGINFO_REQUEST'
export const CORE_UPDATE_BUILDINGINFO_SUCCESS = 'CORE_UPDATE_BUILDINGINFO_SUCCESS'
export const CORE_UPDATE_BUILDINGINFO_FAILURE = 'CORE_UPDATE_BUILDINGINFO_FAILURE'

export const CORE_CREATE_BUILDING_REQUEST = 'CORE_CREATE_BUILDING_REQUEST'
export const CORE_CREATE_BUILDING_SUCCESS = 'CORE_CREATE_BUILDING_SUCCESS'
export const CORE_CREATE_BUILDING_FAILURE = 'CORE_CREATE_BUILDING_FAILURE'

export const CORE_LOAD_ALLFLOOR_REQUEST = 'CORE_LOAD_ALLFLOOR_REQUEST'
export const CORE_LOAD_ALLFLOOR_SUCCESS = 'CORE_LOAD_ALLFLOOR_SUCCESS'
export const CORE_LOAD_ALLFLOOR_FAILURE = 'CORE_LOAD_ALLFLOOR_FAILURE'

export const CORE_DELETE_FLOOR_REQUEST = 'CORE_DELETE_FLOOR_REQUEST'
export const CORE_DELETE_FLOOR_SUCCESS = 'CORE_DELETE_FLOOR_SUCCESS'
export const CORE_DELETE_FLOOR_FAILURE = 'CORE_DELETE_FLOOR_FAILURE'

export const CORE_LOAD_FLOORINFO_REQUEST = 'CORE_LOAD_FLOORINFO_REQUEST'
export const CORE_LOAD_FLOORINFO_SUCCESS = 'CORE_LOAD_FLOORINFO_SUCCESS'
export const CORE_LOAD_FLOORINFO_FAILURE = 'CORE_LOAD_FLOORINFO_FAILURE'

export const CORE_UPDATE_FLOORINFO_REQUEST = 'CORE_UPDATE_FLOORINFO_REQUEST'
export const CORE_UPDATE_FLOORINFO_SUCCESS = 'CORE_UPDATE_FLOORINFO_SUCCESS'
export const CORE_UPDATE_FLOORINFO_FAILURE = 'CORE_UPDATE_FLOORINFO_FAILURE'

export const CORE_CREATE_FLOOR_REQUEST = 'CORE_CREATE_FLOOR_REQUEST'
export const CORE_CREATE_FLOOR_SUCCESS = 'CORE_CREATE_FLOOR_SUCCESS'
export const CORE_CREATE_FLOOR_FAILURE = 'CORE_CREATE_FLOOR_FAILURE'

export const CORE_LOAD_ALLZONE_REQUEST = 'CORE_LOAD_ALLZONE_REQUEST'
export const CORE_LOAD_ALLZONE_SUCCESS = 'CORE_LOAD_ALLZONE_SUCCESS'
export const CORE_LOAD_ALLZONE_FAILURE = 'CORE_LOAD_ALLZONE_FAILURE'

export const CORE_DELETE_ZONE_REQUEST = 'CORE_DELETE_ZONE_REQUEST'
export const CORE_DELETE_ZONE_SUCCESS = 'CORE_DELETE_ZONE_SUCCESS'
export const CORE_DELETE_ZONE_FAILURE = 'CORE_DELETE_ZONE_FAILURE'

export const CORE_LOAD_ZONEINFO_REQUEST = 'CORE_LOAD_ZONEINFO_REQUEST'
export const CORE_LOAD_ZONEINFO_SUCCESS = 'CORE_LOAD_ZONEINFO_SUCCESS'
export const CORE_LOAD_ZONEINFO_FAILURE = 'CORE_LOAD_ZONEINFO_FAILURE'

export const CORE_UPDATE_ZONEINFO_REQUEST = 'CORE_UPDATE_ZONEINFO_REQUEST'
export const CORE_UPDATE_ZONEINFO_SUCCESS = 'CORE_UPDATE_ZONEINFO_SUCCESS'
export const CORE_UPDATE_ZONEINFO_FAILURE = 'CORE_UPDATE_ZONEINFO_FAILURE'

export const CORE_CREATE_ZONE_REQUEST = 'CORE_CREATE_ZONE_REQUEST'
export const CORE_CREATE_ZONE_SUCCESS = 'CORE_CREATE_ZONE_SUCCESS'
export const CORE_CREATE_ZONE_FAILURE = 'CORE_CREATE_ZONE_FAILURE'

export const CORE_LOAD_ALLBACKGROUND_REQUEST = 'CORE_LOAD_ALLBACKGROUND_REQUEST'
export const CORE_LOAD_ALLBACKGROUND_SUCCESS = 'CORE_LOAD_ALLBACKGROUND_SUCCESS'
export const CORE_LOAD_ALLBACKGROUND_FAILURE = 'CORE_LOAD_ALLBACKGROUND_FAILURE'

export const CORE_DELETE_BACKGROUND_REQUEST = 'CORE_DELETE_BACKGROUND_REQUEST'
export const CORE_DELETE_BACKGROUND_SUCCESS = 'CORE_DELETE_BACKGROUND_SUCCESS'
export const CORE_DELETE_BACKGROUND_FAILURE = 'CORE_DELETE_BACKGROUND_FAILURE'

export const CORE_LOAD_BACKGROUNDINFO_REQUEST = 'CORE_LOAD_BACKGROUNDINFO_REQUEST'
export const CORE_LOAD_BACKGROUNDINFO_SUCCESS = 'CORE_LOAD_BACKGROUNDINFO_SUCCESS'
export const CORE_LOAD_BACKGROUNDINFO_FAILURE = 'CORE_LOAD_BACKGROUNDINFO_FAILURE'

export const CORE_UPDATE_BACKGROUNDINFO_REQUEST = 'CORE_UPDATE_BACKGROUNDINFO_REQUEST'
export const CORE_UPDATE_BACKGROUNDINFO_SUCCESS = 'CORE_UPDATE_BACKGROUNDINFO_SUCCESS'
export const CORE_UPDATE_BACKGROUNDINFO_FAILURE = 'CORE_UPDATE_BACKGROUNDINFO_FAILURE'

export const CORE_CREATE_BACKGROUND_REQUEST = 'CORE_CREATE_BACKGROUND_REQUEST'
export const CORE_CREATE_BACKGROUND_SUCCESS = 'CORE_CREATE_BACKGROUND_SUCCESS'
export const CORE_CREATE_BACKGROUND_FAILURE = 'CORE_CREATE_BACKGROUND_FAILURE'

export const CORE_UPDATE_DEFAULTBACKGROUND_REQUEST = 'CORE_UPDATE_DEFAULTBACKGROUND_REQUEST'
export const CORE_UPDATE_DEFAULTBACKGROUND_SUCCESS = 'CORE_UPDATE_DEFAULTBACKGROUND_SUCCESS'
export const CORE_UPDATE_DEFAULTBACKGROUND_FAILURE = 'CORE_UPDATE_DEFAULTBACKGROUND_FAILURE'

export const CORE_GET_CATEGORY_INFO_REQUEST = 'CORE_GET_CATEGORY_INFO_REQUEST'
export const CORE_GET_CATEGORY_INFO_SUCCESS = 'CORE_GET_CATEGORY_INFO_SUCCESS'
export const CORE_GET_CATEGORY_INFO_FAILURE = 'CORE_GET_CATEGORY_INFO_FAILURE'

export const CORE_UPDATE_FB_CATEGORY_REQUEST = 'CORE_UPDATE_FB_CATEGORY_REQUEST'
export const CORE_UPDATE_FB_CATEGORY_SUCCESS = 'CORE_UPDATE_FB_CATEGORY_SUCCESS'
export const CORE_UPDATE_FB_CATEGORY_FAILURE = 'CORE_UPDATE_FB_CATEGORY_FAILURE'

export const CORE_CREATE_FB_CATEGORY_REQUEST = 'CORE_CREATE_FB_CATEGORY_REQUEST'
export const CORE_CREATE_FB_CATEGORY_SUCCESS = 'CORE_CREATE_FB_CATEGORY_SUCCESS'
export const CORE_CREATE_FB_CATEGORY_FAILURE = 'CORE_CREATE_FB_CATEGORY_FAILURE'

export const CORE_DELETE_FB_CATEGORY_REQUEST = 'CORE_DELETE_FB_CATEGORY_REQUEST'
export const CORE_DELETE_FB_CATEGORY_SUCCESS = 'CORE_DELETE_FB_CATEGORY_SUCCESS'
export const CORE_DELETE_FB_CATEGORY_FAILURE = 'CORE_DELETE_FB_CATEGORY_FAILURE'

export const CORE_LOAD_ALL_USERSAD_REQUEST = 'CORE_LOAD_ALL_USERSAD_REQUEST'
export const CORE_LOAD_ALL_USERSAD_SUCCESS = 'CORE_LOAD_ALL_USERSAD_SUCCESS'
export const CORE_LOAD_ALL_USERSAD_FAILURE = 'CORE_LOAD_ALL_USERSAD_FAILURE'

export const CORE_CHECK_AD_REQUEST = 'CORE_CHECK_AD_REQUEST'
export const CORE_CHECK_AD_SUCCESS = 'CORE_CHECK_AD_SUCCESS'
export const CORE_CHECK_AD_FAILURE = 'CORE_CHECK_AD_FAILURE'

export const CORE_CHECK_TMS_REQUEST = 'CORE_CHECK_TMS_REQUEST'
export const CORE_CHECK_TMS_SUCCESS = 'CORE_CHECK_TMS_SUCCESS'
export const CORE_CHECK_TMS_FAILURE = 'CORE_CHECK_TMS_FAILURE'

export const CORE_CHECK_CMR_REQUEST = 'CORE_CHECK_CMR_REQUEST'
export const CORE_CHECK_CMR_SUCCESS = 'CORE_CHECK_CMR_SUCCESS'
export const CORE_CHECK_CMR_FAILURE = 'CORE_CHECK_CMR_FAILURE'

export const CORE_CHECK_BOT_REQUEST = 'CORE_CHECK_BOT_REQUEST'
export const CORE_CHECK_BOT_SUCCESS = 'CORE_CHECK_BOT_SUCCESS'
export const CORE_CHECK_BOT_FAILURE = 'CORE_CHECK_BOT_FAILURE'

export const CORE_LOAD_TIMEZOZE_REQUEST = 'CORE_LOAD_TIMEZOZE_REQUEST'
export const CORE_LOAD_TIMEZOZE_SUCCESS = 'CORE_LOAD_TIMEZOZE_SUCCESS'
export const CORE_LOAD_TIMEZOZE_FAILURE = 'CORE_LOAD_TIMEZOZE_FAILURE'

export const CORE_DELETE_IOT_REQUEST = 'CORE_DELETE_IOT_REQUEST'
export const CORE_DELETE_IOT_SUCCESS = 'CORE_DELETE_IOT_SUCCESS'
export const CORE_DELETE_IOT_FAILURE = 'CORE_DELETE_IOT_FAILURE'

export const CORE_UPDATE_IOT_REQUEST = 'CORE_UPDATE_IOT_REQUEST'
export const CORE_UPDATE_IOT_SUCCESS = 'CORE_UPDATE_IOT_SUCCESS'
export const CORE_UPDATE_IOT_FAILURE = 'CORE_UPDATE_IOT_FAILURE'

export const CORE_CREATE_IOT_REQUEST = 'CORE_CREATE_IOT_REQUEST'
export const CORE_CREATE_IOT_SUCCESS = 'CORE_CREATE_IOT_SUCCESS'
export const CORE_CREATE_IOT_FAILURE = 'CORE_CREATE_IOT_FAILURE'

export const CORE_LOAD_IOT_REQUEST = 'CORE_LOAD_IOT_REQUEST'
export const CORE_LOAD_IOT_SUCCESS = 'CORE_LOAD_IOT_SUCCESS'
export const CORE_LOAD_IOT_FAILURE = 'CORE_LOAD_IOT_FAILURE'

export const CORE_GET_IOT_INFO_REQUEST = 'CORE_GET_IOT_INFO_REQUEST'
export const CORE_GET_IOT_INFO_SUCCESS = 'CORE_GET_IOT_INFO_SUCCESS'
export const CORE_GET_IOT_INFO_FAILURE = 'CORE_GET_IOT_INFO_FAILURE'

export const CORE_EDIT_GOOGLE_INTEGRATION_REQUEST = 'CORE_EDIT_GOOGLE_INTEGRATION_REQUEST'
export const CORE_EDIT_GOOGLE_INTEGRATION_SUCCESS = 'CORE_EDIT_GOOGLE_INTEGRATION_SUCCESS'
export const CORE_EDIT_GOOGLE_INTEGRATION_FAILURE = 'CORE_EDIT_GOOGLE_INTEGRATION_FAILURE'

export const CORE_UPDATE_HOTSEAT_REQUEST = 'CORE_UPDATE_HOTSEAT_REQUEST'
export const CORE_UPDATE_HOTSEAT_SUCCESS = 'CORE_UPDATE_HOTSEAT_SUCCESS'
export const CORE_UPDATE_HOTSEAT_FAILURE = 'CORE_UPDATE_HOTSEAT_FAILURE'

export const CORE_LOAD_ALLSEAT_REQUEST = 'CORE_LOAD_ALLSEAT_REQUEST'
export const CORE_LOAD_ALLSEAT_SUCCESS = 'CORE_LOAD_ALLSEAT_SUCCESS'
export const CORE_LOAD_ALLSEAT_FAILURE = 'CORE_LOAD_ALLSEAT_FAILURE'

export const CORE_LOAD_SEAT_ZONE_INFO_REQUEST = 'CORE_LOAD_SEAT_ZONE_INFO_REQUEST'
export const CORE_LOAD_SEAT_ZONE_INFO_SUCCESS = 'CORE_LOAD_SEAT_ZONE_INFO_SUCCESS'
export const CORE_LOAD_SEAT_ZONE_INFO_FAILURE = 'CORE_LOAD_SEAT_ZONE_INFO_FAILURE'

export const CORE_LOAD_SEAT_INFO_REQUEST = 'CORE_LOAD_SEAT_INFO_REQUEST'
export const CORE_LOAD_SEAT_INFO_SUCCESS = 'CORE_LOAD_SEAT_INFO_SUCCESS'
export const CORE_LOAD_SEAT_INFO_FAILURE = 'CORE_LOAD_SEAT_INFO_FAILURE'

export const CORE_LOAD_ALLDISABLESEAT_REQUEST = 'CORE_LOAD_ALLDISABLESEAT_REQUEST'
export const CORE_LOAD_ALLDISABLESEAT_SUCCESS = 'CORE_LOAD_ALLDISABLESEAT_SUCCESS'
export const CORE_LOAD_ALLDISABLESEAT_FAILURE = 'CORE_LOAD_ALLDISABLESEAT_FAILURE'

export const CORE_CREATE_DISABLEDSEAT_REQUEST = 'CORE_CREATE_DISABLEDSEAT_REQUEST'
export const CORE_CREATE_DISABLEDSEAT_SUCCESS = 'CORE_CREATE_DISABLEDSEAT_SUCCESS'
export const CORE_CREATE_DISABLEDSEAT_FAILURE = 'CORE_CREATE_DISABLEDSEAT_FAILURE'

export const CORE_LOAD_DISABLESEATINFO_REQUEST = 'CORE_LOAD_DISABLESEATINFO_REQUEST'
export const CORE_LOAD_DISABLESEATINFO_SUCCESS = 'CORE_LOAD_DISABLESEATINFO_SUCCESS'
export const CORE_LOAD_DISABLESEATINFO_FAILURE = 'CORE_LOAD_DISABLESEATINFO_FAILURE'

export const CORE_UPDATE_DISABLESEATINFO_REQUEST = 'CORE_UPDATE_DISABLESEATINFO_REQUEST'
export const CORE_UPDATE_DISABLESEATINFO_SUCCESS = 'CORE_UPDATE_DISABLESEATINFO_SUCCESS'
export const CORE_UPDATE_DISABLESEATINFO_FAILURE = 'CORE_UPDATE_DISABLESEATINFO_FAILURE'

export const CORE_DELETE_DISABLESEATINFO_REQUEST = 'CORE_DELETE_DISABLESEATINFO_REQUEST'
export const CORE_DELETE_DISABLESEATINFO_SUCCESS = 'CORE_DELETE_DISABLESEATINFO_SUCCESS'
export const CORE_DELETE_DISABLESEATINFO_FAILURE = 'CORE_DELETE_DISABLESEATINFO_FAILURE'

export const CORE_SEARCH_ROOMS_REQUEST = 'CORE_SEARCH_ROOMS_REQUEST'
export const CORE_SEARCH_ROOMS_SUCCESS = 'CORE_SEARCH_ROOMS_SUCCESS'
export const CORE_SEARCH_ROOMS_FAILURE = 'CORE_SEARCH_ROOMS_FAILURE'

export const CORE_SEARCH_FLOOR_REQUEST = 'CORE_SEARCH_FLOOR_REQUEST'
export const CORE_SEARCH_FLOOR_SUCCESS = 'CORE_SEARCH_FLOOR_SUCCESS'
export const CORE_SEARCH_FLOOR_FAILURE = 'CORE_SEARCH_FLOOR_FAILURE'

export const CORE_SEARCH_ZONE_REQUEST = 'CORE_SEARCH_ZONE_REQUEST'
export const CORE_SEARCH_ZONE_SUCCESS = 'CORE_SEARCH_ZONE_SUCCESS'
export const CORE_SEARCH_ZONE_FAILURE = 'CORE_SEARCH_ZONE_FAILURE'

export const CORE_SEARCH_IOT_REQUEST = 'CORE_SEARCH_IOT_REQUEST'
export const CORE_SEARCH_IOT_SUCCESS = 'CORE_SEARCH_IOT_SUCCESS'
export const CORE_SEARCH_IOT_FAILURE = 'CORE_SEARCH_IOT_FAILURE'

export const CORE_SEARCH_USERS_REQUEST = 'CORE_SEARCH_USERS_REQUEST'
export const CORE_SEARCH_USERS_SUCCESS = 'CORE_SEARCH_USERS_SUCCESS'
export const CORE_SEARCH_USERS_FAILURE = 'CORE_SEARCH_USERS_FAILURE'

export const CORE_SEARCH_FBS_REQUEST = 'CORE_SEARCH_FBS_REQUEST'
export const CORE_SEARCH_FBS_SUCCESS = 'CORE_SEARCH_FBS_SUCCESS'
export const CORE_SEARCH_FBS_FAILURE = 'CORE_SEARCH_FBS_FAILURE'

export const CORE_CHECKIN_REQUEST = 'CORE_CHECKIN_REQUEST'
export const CORE_CHECKIN_SUCCESS = 'CORE_CHECKIN_SUCCESS'
export const CORE_CHECKIN_FAILURE = 'CORE_CHECKIN_FAILURE'

export const CORE_CHECKOUT_REQUEST = 'CORE_CHECKOUT_REQUEST'
export const CORE_CHECKOUT_SUCCESS = 'CORE_CHECKOUT_SUCCESS'
export const CORE_CHECKOUT_FAILURE = 'CORE_CHECKOUT_FAILURE'

export const CORE_DELETE_EVENT_REQUEST = 'CORE_DELETE_EVENT_REQUEST'
export const CORE_DELETE_EVENT_SUCCESS = 'CORE_DELETE_EVENT_SUCCESS'
export const CORE_DELETE_EVENT_FAILURE = 'CORE_DELETE_EVENT_FAILURE'

export const CORE_RESET_PASSWORD_REQUEST = 'CORE_RESET_PASSWORD_REQUEST'
export const CORE_RESET_PASSWORD_SUCCESS = 'CORE_RESET_PASSWORD_SUCCESS'
export const CORE_RESET_PASSWORD_FAILURE = 'CORE_RESET_PASSWORD_FAILURE'

export const CORE_LOAD_IOT_ROOMREGIS_REQUEST = 'CORE_LOAD_IOT_ROOMREGIS_REQUEST'
export const CORE_LOAD_IOT_ROOMREGIS_SUCCESS = 'CORE_LOAD_IOT_ROOMREGIS_SUCCESS'
export const CORE_LOAD_IOT_ROOMREGIS_FAILURE = 'CORE_LOAD_IOT_ROOMREGIS_FAILURE'

export const CORE_GET_IOT_ROOMREGIS_INFO_REQUEST = 'CORE_GET_IOT_ROOMREGIS_INFO_REQUEST'
export const CORE_GET_IOT_ROOMREGIS_INFO_SUCCESS = 'CORE_GET_IOT_ROOMREGIS_INFO_SUCCESS'
export const CORE_GET_IOT_ROOMREGIS_INFO_FAILURE = 'CORE_GET_IOT_ROOMREGIS_INFO_FAILURE'

export const CORE_CREATE_IOT_ROOMREGIS_REQUEST = 'CORE_CREATE_IOT_ROOMREGIS_REQUEST'
export const CORE_CREATE_IOT_ROOMREGIS_SUCCESS = 'CORE_CREATE_IOT_ROOMREGIS_SUCCESS'
export const CORE_CREATE_IOT_ROOMREGIS_FAILURE = 'CORE_CREATE_IOT_ROOMREGIS_FAILURE'

export const CORE_DELETE_IOT_ROOMREGIS_REQUEST = 'CORE_DELETE_IOT_ROOMREGIS_REQUEST'
export const CORE_DELETE_IOT_ROOMREGIS_SUCCESS = 'CORE_DELETE_IOT_ROOMREGIS_SUCCESS'
export const CORE_DELETE_IOT_ROOMREGIS_FAILURE = 'CORE_DELETE_IOT_ROOMREGIS_FAILURE'

export const CORE_LOAD_DISPLAY_REQUEST = 'CORE_LOAD_DISPLAY_REQUEST'
export const CORE_LOAD_DISPLAY_SUCCESS = 'CORE_LOAD_DISPLAY_SUCCESS'
export const CORE_LOAD_DISPLAY_FAILURE = 'CORE_LOAD_DISPLAY_FAILURE'

export const CORE_GET_DISPLAY_INFO_REQUEST = 'CORE_GET_DISPLAY_INFO_REQUEST'
export const CORE_GET_DISPLAY_INFO_SUCCESS = 'CORE_GET_DISPLAY_INFO_SUCCESS'
export const CORE_GET_DISPLAY_INFO_FAILURE = 'CORE_GET_DISPLAY_INFO_FAILURE'

export const CORE_CREATE_DISPLAY_REQUEST = 'CORE_CREATE_DISPLAY_REQUEST'
export const CORE_CREATE_DISPLAY_SUCCESS = 'CORE_CREATE_DISPLAY_SUCCESS'
export const CORE_CREATE_DISPLAY_FAILURE = 'CORE_CREATE_DISPLAY_FAILURE'

export const CORE_DELETE_DISPLAY_REQUEST = 'CORE_DELETE_DISPLAY_REQUEST'
export const CORE_DELETE_DISPLAY_SUCCESS = 'CORE_DELETE_DISPLAY_SUCCESS'
export const CORE_DELETE_DISPLAY_FAILURE = 'CORE_DELETE_DISPLAY_FAILURE'

export const CORE_UPDATE_DISPLAY_REQUEST = 'CORE_UPDATE_DISPLAY_REQUEST'
export const CORE_UPDATE_DISPLAY_SUCCESS = 'CORE_UPDATE_DISPLAY_SUCCESS'
export const CORE_UPDATE_DISPLAY_FAILURE = 'CORE_UPDATE_DISPLAY_FAILURE'

export const PROFILE_CENTER_LOAD_INFO_REQUEST = 'PROFILE_CENTER_LOAD_INFO_REQUEST'
export const PROFILE_CENTER_LOAD_INFO_SUCCESS = 'PROFILE_CENTER_LOAD_INFO_SUCCESS'
export const PROFILE_CENTER_LOAD_INFO_FAILURE = 'PROFILE_CENTER_LOAD_INFO_FAILURE'

export const PROFILE_CENTER_UPDATE_ROOM_CONFIG_REQUEST = 'PROFILE_CENTER_UPDATE_ROOM_CONFIG_REQUEST'
export const PROFILE_CENTER_UPDATE_ROOM_CONFIG_SUCCESS = 'PROFILE_CENTER_UPDATE_ROOM_CONFIG_SUCCESS'
export const PROFILE_CENTER_UPDATE_ROOM_CONFIG_FAILURE = 'PROFILE_CENTER_UPDATE_ROOM_CONFIG_FAILURE'

export const PROFILE_CENTER_UNREGISTERE_ROOM_CONFIG_REQUEST = 'PROFILE_CENTER_UNREGISTERE_ROOM_CONFIG_REQUEST'
export const PROFILE_CENTER_UNREGISTERE_ROOM_CONFIG_SUCCESS = 'PROFILE_CENTER_UNREGISTERE_ROOM_CONFIG_SUCCESS'
export const PROFILE_CENTER_UNREGISTERE_ROOM_CONFIG_FAILURE = 'PROFILE_CENTER_UNREGISTERE_ROOM_CONFIG_FAILURE'

export const CORE_LOAD_ALL_ROOMDISABLE_REQUEST = 'CORE_LOAD_ALL_ROOMDISABLE_REQUEST'
export const CORE_LOAD_ALL_ROOMDISABLE_SUCCESS = 'CORE_LOAD_ALL_ROOMDISABLE_SUCCESS'
export const CORE_LOAD_ALL_ROOMDISABLE_FAILURE = 'CORE_LOAD_ALL_ROOMDISABLE_FAILURE'

export const CORE_LOAD_ROOMDISABLE_REQUEST = 'CORE_LOAD_ROOMDISABLE_REQUEST'
export const CORE_LOAD_ROOMDISABLE_SUCCESS = 'CORE_LOAD_ROOMDISABLE_SUCCESS'
export const CORE_LOAD_ROOMDISABLE_FAILURE = 'CORE_LOAD_ROOMDISABLE_FAILURE'

export const CORE_CREATE_ROOMDISABLE_REQUEST = 'CORE_CREATE_ROOMDISABLE_REQUEST'
export const CORE_CREATE_ROOMDISABLE_SUCCESS = 'CORE_CREATE_ROOMDISABLE_SUCCESS'
export const CORE_CREATE_ROOMDISABLE_FAILURE = 'CORE_CREATE_ROOMDISABLE_FAILURE'

export const CORE_UPDATE_ROOMDISABLE_REQUEST = 'CORE_UPDATE_ROOMDISABLE_REQUEST'
export const CORE_UPDATE_ROOMDISABLE_SUCCESS = 'CORE_UPDATE_ROOMDISABLE_SUCCESS'
export const CORE_UPDATE_ROOMDISABLE_FAILURE = 'CORE_UPDATE_ROOMDISABLE_FAILURE'

export const CORE_DELETE_ROOMDISABLE_REQUEST = 'CORE_DELETE_ROOMDISABLE_REQUEST'
export const CORE_DELETE_ROOMDISABLE_SUCCESS = 'CORE_DELETE_ROOMDISABLE_SUCCESS'
export const CORE_DELETE_ROOMDISABLE_FAILURE = 'CORE_DELETE_ROOMDISABLE_FAILURE'

export const CORE_LOAD_VC_LIST_REQUEST = 'CORE_LOAD_VC_LIST_REQUEST'
export const CORE_LOAD_VC_LIST_SUCCESS = 'CORE_LOAD_VC_LIST_SUCCESS'
export const CORE_LOAD_VC_LIST_FAILURE = 'CORE_LOAD_VC_LIST_FAILURE'

export const CORE_LOAD_CONCURRENT_REQUEST = 'CORE_LOAD_CONCURRENT_REQUEST'
export const CORE_LOAD_CONCURRENT_SUCCESS = 'CORE_LOAD_CONCURRENT_SUCCESS'
export const CORE_LOAD_CONCURRENT_FAILURE = 'CORE_LOAD_CONCURRENT_FAILURE'

export const CORE_DELETE_CONCURRENT_REQUEST = 'CORE_DELETE_CONCURRENT_REQUEST'
export const CORE_DELETE_CONCURRENT_SUCCESS = 'CORE_DELETE_CONCURRENT_SUCCESS'
export const CORE_DELETE_CONCURRENT_FAILURE = 'CORE_DELETE_CONCURRENT_FAILURE'

export const CORE_LOAD_ROLES_REQUEST = 'CORE_LOAD_ROLES_REQUEST'
export const CORE_LOAD_ROLES_SUCCESS = 'CORE_LOAD_ROLES_SUCCESS'
export const CORE_LOAD_ROLES_FAILURE = 'CORE_LOAD_ROLES_FAILURE'

export const CORE_CREATE_ROLE_REQUEST = 'CORE_CREATE_ROLE_REQUEST'
export const CORE_CREATE_ROLE_SUCCESS = 'CORE_CREATE_ROLE_SUCCESS'
export const CORE_CREATE_ROLE_FAILURE = 'CORE_CREATE_ROLE_FAILURE'

export const CORE_LOAD_ROLE_INFO_REQUEST = 'CORE_LOAD_ROLE_INFO_REQUEST'
export const CORE_LOAD_ROLE_INFO_SUCCESS = 'CORE_LOAD_ROLE_INFO_SUCCESS'
export const CORE_LOAD_ROLE_INFO_FAILURE = 'CORE_LOAD_ROLE_INFO_FAILURE'

export const CORE_UPDATE_ROLE_REQUEST = 'CORE_UPDATE_ROLE_REQUEST'
export const CORE_UPDATE_ROLE_SUCCESS = 'CORE_UPDATE_ROLE_SUCCESS'
export const CORE_UPDATE_ROLE_FAILURE = 'CORE_UPDATE_ROLE_FAILURE'

export const CORE_DELETE_ROLE_REQUEST = 'CORE_DELETE_ROLE_REQUEST'
export const CORE_DELETE_ROLE_SUCCESS = 'CORE_DELETE_ROLE_SUCCESS'
export const CORE_DELETE_ROLE_FAILURE = 'CORE_DELETE_ROLE_FAILURE'

export const CORE_LOAD_EVENT_ROOM_FORMAT_REQUEST = 'CORE_LOAD_EVENT_ROOM_FORMAT_REQUEST'
export const CORE_LOAD_EVENT_ROOM_FORMAT_SUCCESS = 'CORE_LOAD_EVENT_ROOM_FORMAT_SUCCESS'
export const CORE_LOAD_EVENT_ROOM_FORMAT_FAILURE = 'CORE_LOAD_EVENT_ROOM_FORMAT_FAILURE'

export const CORE_DELETE_EVENT_ROOM_FORMAT_REQUEST = 'CORE_DELETE_EVENT_ROOM_FORMAT_REQUEST'
export const CORE_DELETE_EVENT_ROOM_FORMAT_SUCCESS = 'CORE_DELETE_EVENT_ROOM_FORMAT_SUCCESS'
export const CORE_DELETE_EVENT_ROOM_FORMAT_FAILURE = 'CORE_DELETE_EVENT_ROOM_FORMAT_FAILURE'

export const CORE_LOAD_EVENT_ROOM_FORMAT_INFO_REQUEST = 'CORE_LOAD_EVENT_ROOM_FORMAT_INFO_REQUEST'
export const CORE_LOAD_EVENT_ROOM_FORMAT_INFO_SUCCESS = 'CORE_LOAD_EVENT_ROOM_FORMAT_INFO_SUCCESS'
export const CORE_LOAD_EVENT_ROOM_FORMAT_INFO_FAILURE = 'CORE_LOAD_EVENT_ROOM_FORMAT_INFO_FAILURE'

export const CORE_UPDATE_EVENT_ROOM_FORMAT_INFO_REQUEST = 'CORE_UPDATE_EVENT_ROOM_FORMAT_INFO_REQUEST'
export const CORE_UPDATE_EVENT_ROOM_FORMAT_INFO_SUCCESS = 'CORE_UPDATE_EVENT_ROOM_FORMAT_INFO_SUCCESS'
export const CORE_UPDATE_EVENT_ROOM_FORMAT_INFO_FAILURE = 'CORE_UPDATE_EVENT_ROOM_FORMAT_INFO_FAILURE'

export const CORE_CREATE_EVENT_ROOM_FORMAT_REQUEST = 'CORE_CREATE_EVENT_ROOM_FORMAT_REQUEST'
export const CORE_CREATE_EVENT_ROOM_FORMAT_SUCCESS = 'CORE_CREATE_EVENT_ROOM_FORMAT_SUCCESS'
export const CORE_CREATE_EVENT_ROOM_FORMAT_FAILURE = 'CORE_CREATE_EVENT_ROOM_FORMAT_FAILURE'

export const CORE_LOAD_ORDER_FBS_REQUEST = 'CORE_LOAD_ORDER_FBS_REQUEST'
export const CORE_LOAD_ORDER_FBS_SUCCESS = 'CORE_LOAD_ORDER_FBS_SUCCESS'
export const CORE_LOAD_ORDER_FBS_FAILURE = 'CORE_LOAD_ORDER_FBS_FAILURE'

export const CORE_DELETE_ORDER_FBS_REQUEST = 'CORE_DELETE_ORDER_FBS_REQUEST'
export const CORE_DELETE_ORDER_FBS_SUCCESS = 'CORE_DELETE_ORDER_FBS_SUCCESS'
export const CORE_DELETE_ORDER_FBS_FAILURE = 'CORE_DELETE_ORDER_FBS_FAILURE'

export const CORE_LOAD_ORDER_FBS_INFO_REQUEST = 'CORE_LOAD_ORDER_FBS_INFO_REQUEST'
export const CORE_LOAD_ORDER_FBS_INFO_SUCCESS = 'CORE_LOAD_ORDER_FBS_INFO_SUCCESS'
export const CORE_LOAD_ORDER_FBS_INFO_FAILURE = 'CORE_LOAD_ORDER_FBS_INFO_FAILURE'

export const CORE_UPDATE_ORDER_FBS_INFO_REQUEST = 'CORE_UPDATE_ORDER_FBS_INFO_REQUEST'
export const CORE_UPDATE_ORDER_FBS_INFO_SUCCESS = 'CORE_UPDATE_ORDER_FBS_INFO_SUCCESS'
export const CORE_UPDATE_ORDER_FBS_INFO_FAILURE = 'CORE_UPDATE_ORDER_FBS_INFO_FAILURE'

export const CORE_CREATE_ORDER_FBS_REQUEST = 'CORE_CREATE_ORDER_FBS_REQUEST'
export const CORE_CREATE_ORDER_FBS_SUCCESS = 'CORE_CREATE_ORDER_FBS_SUCCESS'
export const CORE_CREATE_ORDER_FBS_FAILURE = 'CORE_CREATE_ORDER_FBS_FAILURE'

export const CORE_LOAD_ORDER_AMENITY_REQUEST = 'CORE_LOAD_ORDER_AMENITY_REQUEST'
export const CORE_LOAD_ORDER_AMENITY_SUCCESS = 'CORE_LOAD_ORDER_AMENITY_SUCCESS'
export const CORE_LOAD_ORDER_AMENITY_FAILURE = 'CORE_LOAD_ORDER_AMENITY_FAILURE'

export const CORE_DELETE_ORDER_AMENITY_REQUEST = 'CORE_DELETE_ORDER_AMENITY_REQUEST'
export const CORE_DELETE_ORDER_AMENITY_SUCCESS = 'CORE_DELETE_ORDER_AMENITY_SUCCESS'
export const CORE_DELETE_ORDER_AMENITY_FAILURE = 'CORE_DELETE_ORDER_AMENITY_FAILURE'

export const CORE_LOAD_ORDER_AMENITY_INFO_REQUEST = 'CORE_LOAD_ORDER_AMENITY_INFO_REQUEST'
export const CORE_LOAD_ORDER_AMENITY_INFO_SUCCESS = 'CORE_LOAD_ORDER_AMENITY_INFO_SUCCESS'
export const CORE_LOAD_ORDER_AMENITY_INFO_FAILURE = 'CORE_LOAD_ORDER_AMENITY_INFO_FAILURE'

export const CORE_UPDATE_ORDER_AMENITY_INFO_REQUEST = 'CORE_UPDATE_ORDER_AMENITY_INFO_REQUEST'
export const CORE_UPDATE_ORDER_AMENITY_INFO_SUCCESS = 'CORE_UPDATE_ORDER_AMENITY_INFO_SUCCESS'
export const CORE_UPDATE_ORDER_AMENITY_INFO_FAILURE = 'CORE_UPDATE_ORDER_AMENITY_INFO_FAILURE'

export const O365_LOAD_ROOMS_BY_ADMIN_ID_REQUEST = 'O365_LOAD_ROOMS_BY_ADMIN_ID_REQUEST'
export const O365_LOAD_ROOMS_BY_ADMIN_ID_SUCCESS = 'O365_LOAD_ROOMS_BY_ADMIN_ID_SUCCESS'
export const O365_LOAD_ROOMS_BY_ADMIN_ID_FAILURE = 'O365_LOAD_ROOMS_BY_ADMIN_ID_FAILURE'

export const CORE_GET_ROOM_AVAILABLE_ORDER_REQUEST = 'CORE_GET_ROOM_AVAILABLE_ORDER_REQUEST'
export const CORE_GET_ROOM_AVAILABLE_ORDER_SUCCESS = 'CORE_GET_ROOM_AVAILABLE_ORDER_SUCCESS'
export const CORE_GET_ROOM_AVAILABLE_ORDER_FAILURE = 'CORE_GET_ROOM_AVAILABLE_ORDER_FAILURE'

export const CORE_CREATE_ORDER_REQUEST = 'CORE_CREATE_ORDER_REQUEST'
export const CORE_CREATE_ORDER_SUCCESS = 'CORE_CREATE_ORDER_SUCCESS'
export const CORE_CREATE_ORDER_FAILURE = 'CORE_CREATE_ORDER_FAILURE'

export const CORE_LOAD_EVENTTYPE_REQUEST = 'CORE_LOAD_EVENTTYPE_REQUEST'
export const CORE_LOAD_EVENTTYPE_SUCCESS = 'CORE_LOAD_EVENTTYPE_SUCCESS'
export const CORE_LOAD_EVENTTYPE_FAILURE = 'CORE_LOAD_EVENTTYPE_FAILURE'

export const CORE_LOAD_EVENTTYPE_INFO_REQUEST = 'CORE_LOAD_EVENTTYPE_INFO_REQUEST'
export const CORE_LOAD_EVENTTYPE_INFO_SUCCESS = 'CORE_LOAD_EVENTTYPE_INFO_SUCCESS'
export const CORE_LOAD_EVENTTYPE_INFO_FAILURE = 'CORE_LOAD_EVENTTYPE_INFO_FAILURE'

export const CORE_CREATE_EVENTTYPE_REQUEST = 'CORE_CREATE_EVENTTYPE_REQUEST'
export const CORE_CREATE_EVENTTYPE_SUCCESS = 'CORE_CREATE_EVENTTYPE_SUCCESS'
export const CORE_CREATE_EVENTTYPE_FAILURE = 'CORE_CREATE_EVENTTYPE_FAILURE'

export const CORE_UPDATE_EVENTTYPE_REQUEST = 'CORE_UPDATE_EVENTTYPE_REQUEST'
export const CORE_UPDATE_EVENTTYPE_SUCCESS = 'CORE_UPDATE_EVENTTYPE_SUCCESS'
export const CORE_UPDATE_EVENTTYPE_FAILURE = 'CORE_UPDATE_EVENTTYPE_FAILURE'

export const CORE_DELETE_EVENTTYPE_REQUEST = 'CORE_DELETE_EVENTTYPE_REQUEST'
export const CORE_DELETE_EVENTTYPE_SUCCESS = 'CORE_DELETE_EVENTTYPE_SUCCESS'
export const CORE_DELETE_EVENTTYPE_FAILURE = 'CORE_DELETE_EVENTTYPE_FAILURE'

export const CORE_UNREGISTER_DISPLAY_REQUEST = 'CORE_UNREGISTER_DISPLAY_REQUEST'
export const CORE_UNREGISTER_DISPLAY_SUCCESS = 'CORE_UNREGISTER_DISPLAY_SUCCESS'
export const CORE_UNREGISTER_DISPLAY_FAILURE = 'CORE_UNREGISTER_DISPLAY_FAILURE'

export const CORE_UNREGISTER_PROFILE_REQUEST = 'CORE_UNREGISTER_PROFILE_REQUEST'
export const CORE_UNREGISTER_PROFILE_SUCCESS = 'CORE_UNREGISTER_PROFILE_SUCCESS'
export const CORE_UNREGISTER_PROFILE_FAILURE = 'CORE_UNREGISTER_PROFILE_FAILURE'

export const CORE_UNREGISTER_IOT_REQUEST = 'CORE_UNREGISTER_IOT_REQUEST'
export const CORE_UNREGISTER_IOT_SUCCESS = 'CORE_UNREGISTER_IOT_SUCCESS'
export const CORE_UNREGISTER_IOT_FAILURE = 'CORE_UNREGISTER_IOT_FAILURE'

export const CORE_LOAD_ALL_IMPORT_USER_O365_REQUEST = 'CORE_LOAD_ALL_IMPORT_USER_O365_REQUEST'
export const CORE_LOAD_ALL_IMPORT_USER_O365_SUCCESS = 'CORE_LOAD_ALL_IMPORT_USER_O365_SUCCESS'
export const CORE_LOAD_ALL_IMPORT_USER_O365_FAILURE = 'CORE_LOAD_ALL_IMPORT_USER_O365_FAILURE'

export const CORE_IMPORT_USER_O365_REQUEST = 'CORE_IMPORT_USER_O365_REQUEST'
export const CORE_IMPORT_USER_O365_SUCCESS = 'CORE_IMPORT_USER_O365_SUCCESS'
export const CORE_IMPORT_USER_O365_FAILURE = 'CORE_IMPORT_USER_O365_FAILURE'

export const CORE_SYNC_ROLE_REQUEST = 'CORE_SYNC_ROLE_REQUEST'
export const CORE_SYNC_ROLE_SUCCESS = 'CORE_SYNC_ROLE_SUCCESS'
export const CORE_SYNC_ROLE_FAILURE = 'CORE_SYNC_ROLE_FAILURE'

export const CORE_LOAD_IOT_MODULE_REQUEST = 'CORE_LOAD_IOT_MODULE_REQUEST'
export const CORE_LOAD_IOT_MODULE_SUCCESS = 'CORE_LOAD_IOT_MODULE_SUCCESS'
export const CORE_LOAD_IOT_MODULE_FAILURE = 'CORE_LOAD_IOT_MODULE_FAILURE'

export const CORE_CREATE_IOT_MODULE_REQUEST = 'CORE_CREATE_IOT_MODULE_REQUEST'
export const CORE_CREATE_IOT_MODULE_SUCCESS = 'CORE_CREATE_IOT_MODULE_SUCCESS'
export const CORE_CREATE_IOT_MODULE_FAILURE = 'CORE_CREATE_IOT_MODULE_FAILURE'

export const CORE_LOAD_IOTINFO_REQUEST = 'CORE_LOAD_IOTINFO_REQUEST'
export const CORE_LOAD_IOTINFO_SUCCESS = 'CORE_LOAD_IOTINFO_SUCCESS'
export const CORE_LOAD_IOTINFO_FAILURE = 'CORE_LOAD_IOTINFO_FAILURE'

export const CORE_UPDATE_IOTINFO_REQUEST = 'CORE_UPDATE_IOTINFO_REQUEST'
export const CORE_UPDATE_IOTINFO_SUCCESS = 'CORE_UPDATE_IOTINFO_SUCCESS'
export const CORE_UPDATE_IOTINFO_FAILURE = 'CORE_UPDATE_IOTINFO_FAILURE'

export const CORE_GET_IOT_INFO_WITH_MODULE_REQUEST = 'CORE_GET_IOT_INFO_WITH_MODULE_REQUEST'
export const CORE_GET_IOT_INFO_WITH_MODULE_SUCCESS = 'CORE_GET_IOT_INFO_WITH_MODULE_SUCCESS'
export const CORE_GET_IOT_INFO_WITH_MODULE_FAILURE = 'CORE_GET_IOT_INFO_WITH_MODULE_FAILURE'

export const CORE_GET_ALL_IOT_MODULE_REQUEST = 'CORE_GET_ALL_IOT_MODULE_REQUEST'
export const CORE_GET_ALL_IOT_MODULE_SUCCESS = 'CORE_GET_ALL_IOT_MODULE_SUCCESS'
export const CORE_GET_ALL_IOT_MODULE_FAILURE = 'CORE_GET_ALL_IOT_MODULE_FAILURE'

export const CORE_UPDATE_IOT_DATA_REQUEST = 'CORE_UPDATE_IOT_DATA_REQUEST'
export const CORE_UPDATE_IOT_DATA_SUCCESS = 'CORE_UPDATE_IOT_DATA_SUCCESS'
export const CORE_UPDATE_IOT_DATA_FAILURE = 'CORE_UPDATE_IOT_DATA_FAILURE'

export const CORE_LOAD_ALL_TEMPORARY_CLOSE_REQUEST = 'CORE_LOAD_ALL_TEMPORARY_CLOSE_REQUEST'
export const CORE_LOAD_ALL_TEMPORARY_CLOSE_SUCCESS = 'CORE_LOAD_ALL_TEMPORARY_CLOSE_SUCCESS'
export const CORE_LOAD_ALL_TEMPORARY_CLOSE_FAILURE = 'CORE_LOAD_ALL_TEMPORARY_CLOSE_FAILURE'

export const CORE_CREATE_TEMP_CLOSE_REQUEST = 'CORE_CREATE_TEMP_CLOSE_REQUEST'
export const CORE_CREATE_TEMP_CLOSE_SUCCESS = 'CORE_CREATE_TEMP_CLOSE_SUCCESS'
export const CORE_CREATE_TEMP_CLOSE_FAILURE = 'CORE_CREATE_TEMP_CLOSE_FAILURE'

export const CORE_DELETE_TEMP_CLOSE_REQUEST = 'CORE_DELETE_TEMP_CLOSE_REQUEST'
export const CORE_DELETE_TEMP_CLOSE_SUCCESS = 'CORE_DELETE_TEMP_CLOSE_SUCCESS'
export const CORE_DELETE_TEMP_CLOSE_FAILURE = 'CORE_DELETE_TEMP_CLOSE_FAILURE'

export const CORE_LOAD_TEMPORARY_CLOSE_REQUEST = 'CORE_LOAD_TEMPORARY_CLOSE_REQUEST'
export const CORE_LOAD_TEMPORARY_CLOSE_SUCCESS = 'CORE_LOAD_TEMPORARY_CLOSE_SUCCESS'
export const CORE_LOAD_TEMPORARY_CLOSE_FAILURE = 'CORE_LOAD_TEMPORARY_CLOSE_FAILURE'

export const CORE_UPDATE_TEMP_CLOSE_REQUEST = 'CORE_UPDATE_TEMP_CLOSE_REQUEST'
export const CORE_UPDATE_TEMP_CLOSE_SUCCESS = 'CORE_UPDATE_TEMP_CLOSE_SUCCESS'
export const CORE_UPDATE_TEMP_CLOSE_FAILURE = 'CORE_UPDATE_TEMP_CLOSE_FAILURE'

export const CORE_LOAD_ALL_AVAILABLE_TIMESLOT_REQUEST = 'CORE_LOAD_ALL_AVAILABLE_TIMESLOT_REQUEST'
export const CORE_LOAD_ALL_AVAILABLE_TIMESLOT_SUCCESS = 'CORE_LOAD_ALL_AVAILABLE_TIMESLOT_SUCCESS'
export const CORE_LOAD_ALL_AVAILABLE_TIMESLOT_FAILURE = 'CORE_LOAD_ALL_AVAILABLE_TIMESLOT_FAILURE'

export const CORE_LOAD_AVAILABLE_TIMESLOT_REQUEST = 'CORE_LOAD_AVAILABLE_TIMESLOT_REQUEST'
export const CORE_LOAD_AVAILABLE_TIMESLOT_SUCCESS = 'CORE_LOAD_AVAILABLE_TIMESLOT_SUCCESS'
export const CORE_LOAD_AVAILABLE_TIMESLOT_FAILURE = 'CORE_LOAD_AVAILABLE_TIMESLOT_FAILURE'

export const CORE_CREATE_AVAILABLE_TIMESLOT_REQUEST = 'CORE_CREATE_AVAILABLE_TIMESLOT_REQUEST'
export const CORE_CREATE_AVAILABLE_TIMESLOT_SUCCESS = 'CORE_CREATE_AVAILABLE_TIMESLOT_SUCCESS'
export const CORE_CREATE_AVAILABLE_TIMESLOT_FAILURE = 'CORE_CREATE_AVAILABLE_TIMESLOT_FAILURE'

export const CORE_UPDATE_AVAILABLE_TIMESLOT_REQUEST = 'CORE_UPDATE_AVAILABLE_TIMESLOT_REQUEST'
export const CORE_UPDATE_AVAILABLE_TIMESLOT_SUCCESS = 'CORE_UPDATE_AVAILABLE_TIMESLOT_SUCCESS'
export const CORE_UPDATE_AVAILABLE_TIMESLOT_FAILURE = 'CORE_UPDATE_AVAILABLE_TIMESLOT_FAILURE'

export const CORE_DELETE_AVAILABLE_TIMESLOT_REQUEST = 'CORE_DELETE_AVAILABLE_TIMESLOT_REQUEST'
export const CORE_DELETE_AVAILABLE_TIMESLOT_SUCCESS = 'CORE_DELETE_AVAILABLE_TIMESLOT_SUCCESS'
export const CORE_DELETE_AVAILABLE_TIMESLOT_FAILURE = 'CORE_DELETE_AVAILABLE_TIMESLOT_FAILURE'

export const CORE_CREATE_HOTDESK_ROLE_REQUEST = 'CORE_CREATE_HOTDESK_ROLE_REQUEST'
export const CORE_CREATE_HOTDESK_ROLE_SUCCESS = 'CORE_CREATE_HOTDESK_ROLE_SUCCESS'
export const CORE_CREATE_HOTDESK_ROLE_FAILURE = 'CORE_CREATE_HOTDESK_ROLE_FAILURE'

export const CORE_UPDATE_HOTDESK_ROLE_REQUEST = 'CORE_UPDATE_HOTDESK_ROLE_REQUEST'
export const CORE_UPDATE_HOTDESK_ROLE_SUCCESS = 'CORE_UPDATE_HOTDESK_ROLE_SUCCESS'
export const CORE_UPDATE_HOTDESK_ROLE_FAILURE = 'CORE_UPDATE_HOTDESK_ROLE_FAILURE'

export const CORE_DELETE_HOTDESK_ROLE_REQUEST = 'CORE_DELETE_HOTDESK_ROLE_REQUEST'
export const CORE_DELETE_HOTDESK_ROLE_SUCCESS = 'CORE_DELETE_HOTDESK_ROLE_SUCCESS'
export const CORE_DELETE_HOTDESK_ROLE_FAILURE = 'CORE_DELETE_HOTDESK_ROLE_FAILURE'

export const CORE_LOAD_ALL_HOTDESK_ROLE_REQUEST = 'CORE_LOAD_ALL_HOTDESK_ROLE_REQUEST'
export const CORE_LOAD_ALL_HOTDESK_ROLE_SUCCESS = 'CORE_LOAD_ALL_HOTDESK_ROLE_SUCCESS'
export const CORE_LOAD_ALL_HOTDESK_ROLE_FAILURE = 'CORE_LOAD_ALL_HOTDESK_ROLE_FAILURE'

export const CORE_LOAD_HOTDESK_ROLE_REQUEST = 'CORE_LOAD_HOTDESK_ROLE_REQUEST'
export const CORE_LOAD_HOTDESK_ROLE_SUCCESS = 'CORE_LOAD_HOTDESK_ROLE_SUCCESS'
export const CORE_LOAD_HOTDESK_ROLE_FAILURE = 'CORE_LOAD_HOTDESK_ROLE_FAILURE'

export const CORE_LOAD_ALL_CONTROL_REQUEST = 'CORE_LOAD_ALL_CONTROL_REQUEST'
export const CORE_LOAD_ALL_CONTROL_SUCCESS = 'CORE_LOAD_ALL_CONTROL_SUCCESS'
export const CORE_LOAD_ALL_CONTROL_FAILURE = 'CORE_LOAD_ALL_CONTROL_FAILURE'

export const CORE_LOAD_ALL_IOT_ROOMINFO_REQUEST = 'CORE_LOAD_ALL_IOT_ROOMINFO_REQUEST'
export const CORE_LOAD_ALL_IOT_ROOMINFO_SUCCESS = 'CORE_LOAD_ALL_IOT_ROOMINFO_SUCCESS'
export const CORE_LOAD_ALL_IOT_ROOMINFO_FAILURE = 'CORE_LOAD_ALL_IOT_ROOMINFO_FAILURE'

export const CORE_UPDATE_DOUT_REQUEST = 'CORE_UPDATE_DOUT_REQUEST'
export const CORE_UPDATE_DOUT_SUCCESS = 'CORE_UPDATE_DOUT_SUCCESS'
export const CORE_UPDATE_DOUT_FAILURE = 'CORE_UPDATE_DOUT_FAILURE'

export const CORE_UPDATE_DALI_REQUEST = 'CORE_UPDATE_DALI_REQUEST'
export const CORE_UPDATE_DALI_SUCCESS = 'CORE_UPDATE_DALI_SUCCESS'
export const CORE_UPDATE_DALI_FAILURE = 'CORE_UPDATE_DALI_FAILURE'

export const CORE_UPDATE_DMX_REQUEST = 'CORE_UPDATE_DMX_REQUEST'
export const CORE_UPDATE_DMX_SUCCESS = 'CORE_UPDATE_DMX_SUCCESS'
export const CORE_UPDATE_DMX_FAILURE = 'CORE_UPDATE_DMX_FAILURE'

export const CORE_GET_ALL_LOCATION_INFO_REQUEST = 'CORE_GET_ALL_LOCATION_INFO_REQUEST'
export const CORE_GET_ALL_LOCATION_INFO_SUCCESS = 'CORE_GET_ALL_LOCATION_INFO_SUCCESS'
export const CORE_GET_ALL_LOCATION_INFO_FAILURE = 'CORE_GET_ALL_LOCATION_INFO_FAILURE'
export const CORE_LOAD_ALL_AD_LIST_REQUEST = 'CORE_LOAD_ALL_AD_LIST_REQUEST'
export const CORE_LOAD_ALL_AD_LIST_SUCCESS = 'CORE_LOAD_ALL_AD_LIST_SUCCESS'
export const CORE_LOAD_ALL_AD_LIST_FAILURE = 'CORE_LOAD_ALL_AD_LIST_FAILURE'

export const CORE_IMPORT_USER_AD_REQUEST = 'CORE_IMPORT_USER_AD_REQUEST'
export const CORE_IMPORT_USER_AD_SUCCESS = 'CORE_IMPORT_USER_AD_SUCCESS'
export const CORE_IMPORT_USER_AD_FAILURE = 'CORE_IMPORT_USER_AD_FAILURE'

export const CORE_SYNC_365_USERS_REQUEST = 'CORE_SYNC_365_USERS_REQUEST'
export const CORE_SYNC_365_USERS_SUCCESS = 'CORE_SYNC_365_USERS_SUCCESS'
export const CORE_SYNC_365_USERS_FAILURE = 'CORE_SYNC_365_USERS_FAILURE'


// WEBPACK FOOTER //
// ./src/types.js